<template>
	<div class="container">
		<div class="main_box">
			<!--导航-->
			<navBox></navBox>
			<!--导航-->
			<!--banner-->
			<div class="banner_box">
				<img src="../../assets/img_h5/services/banner_1.webp"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				/>
				<div class="msg_box"
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="300"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="tit">About Us</div>
					<div class="txt">
						From antigens and antibodies to NC membranes and customizable rapid testing solutions, we specialize in developing high-quality raw materials and offering comprehensive medical device solutions.
					</div>
				</div>
			</div>
			<!--banner-->
			<!--块1-->
			<div class="block_1"
				data-aos="fade-up"
				data-aos-duration="400"
				data-aos-delay="200"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="tit_box">
					<div class="left"></div>
					<div class="center">
						<div class="title">UC reagent</div>
						<div class="tit">ABOUT US</div>
					</div>
					<div class="right"></div>
				</div>
				<div class="title_box">
					<div class="txt">
						UC reagent is a multinational biotechnology company based in San Diego well known for R&D and fully personalizable medical diagnostic products. Founded in 2006, UC reagent focuses primarily on raw material development and medical device marketing through world-class research, development, manufacturing and operations teams.
					</div>
					<div class="txt">
						UC reagent provides high quality, competitively priced products and services with fully customizable solutions for any research, production and medical diagnostic needs.
					</div>
					<div class="txt">
						UC reagent production base, located in Bao Ruiyuan Industrial Park, China, contains a GMP, ISO certified factory with full-scale production line and supporting facilities. The current production line provides products for over 100 countries, with milions of users worldwide.
						<!-- In China, our products are manufactured under the name Ruyun®, Hongxia®, Jingshi®, which hold a strong market share in the area. -->
					</div>
					<div class="txt">
						UC reagent is a global supplier of GMP-grade reagents and raw materials, offering variety of antigens and antibodies, positive controls, nitrocellulose (NC) membranes and more. With over 20 years of research and development, we have produced thousands of GMP-grade reagents. These products can be used for in vitro diagnostics, genetic screening, cell culture, preclinical or clinical research.
					</div>
					<div class="txt">
						UC reagent is independent from the University of California system.
					</div>
				</div>
			</div>
			<!--块1-->
			<!--块2-->
			<div class="block_2"
				data-aos="fade-up"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="tit_box">
					<div class="left"></div>
					<div class="center">
						<div class="title">Our Products & Devices</div>
						<div class="tit">OUR PRODUCT</div>
					</div>
					<div class="right"></div>
				</div>
				<div class="list_box">
					<div class="list_tit" @click="goProducts(1, productType[0])">
						<div>{{ productType[0].title }}</div>
						<img src="../../assets/img/about/icon_1.webp" />
					</div>
					<div class="list_tit" @click="goProducts(1, productType[1])">
						<div>{{ productType[1].title }}</div>
						<img src="../../assets/img/about/icon_1.webp" />
					</div>
					<div class="list_el">
						<div class="tit">Product Type</div>
						<div v-for="(value, index) in productList" :key="index" class="list_el_el" @click="goProducts(2, value)">
							<div>{{ value.title }}</div>
							<img src="../../assets/img/about/icon_1.webp" />
						</div>
					</div>
					<div class="list_el">
						<div class="tit">Product Type</div>
						<div v-for="(value, index) in productList2" :key="index" class="list_el_el" @click="goProducts(2, value)">
							<div>{{ value.title }}</div>
							<img src="../../assets/img/about/icon_1.webp" />
						</div>
					</div>
					<div class="list_el">
						<div class="tit">Tested Apps</div>
						<div v-for="(value, index) in appsList" class="list_el_el" @click="goProducts(3, value)">
							<div>{{ value.title }}</div>
							<img src="../../assets/img/about/icon_1.webp" />
						</div>
					</div>
				</div>
			</div>
			<!--块2-->
			<!--块3-->
			<div class="block_3"
				data-aos="fade-up"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="tit_box">
					<div class="left"></div>
					<div class="center">
						<div class="title">Nitrocellulose (NC) Membranes</div>
					</div>
					<div class="right"></div>
				</div>
				<div class="list_box">
					<div class="list_el">● Membrane iM90</div>
					<div class="list_el">● Membrane iM120</div>
					<div class="list_el">● i-Membrane Customized</div>
					<div class="list_el">● Membrane iM95</div>
					<div class="list_el">● Membrane iM125</div>
					<div class="btn_box" @click="goIm">
						Learn More&nbsp;<van-icon name="down" class="icon" size="17" color="#E37542" style="top: 4px;transform: rotate(-90deg);" />
					</div>
					<div class="img_box">
						<img src="../../assets/img_h5/about/block_1.webp" />
						<img src="../../assets/img_h5/about/block_2.webp" />
						<img src="../../assets/img_h5/about/block_3.webp" />
					</div>
				</div>
			</div>
			<!--块3-->
			<!--块4-->
			<div v-if="false" class="block_4"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="title">CLIA Lab Testing</div>
				<div v-for="(value, index) in servicesList" :key="index" class="text" @click="goServices">● {{ value.name }}</div>
			</div>
			<!--块4-->
			<!--块5-->
			<div v-if="false" class="block_5"
				data-aos="fade-up"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="tit_box">
					<div class="left"></div>
					<div class="center">
						<div class="title">About CorDx Union</div>
						<div class="tit">ABOUT US</div>
					</div>
					<div class="right"></div>
				</div>
				<div class="title_box">
					<div class="tit">
						UC reagent is part of CorDx Union, a Global Innovator in Biotechnology and Beyond
					</div>
					<div class="txt">
						CorDx Union is a global biotechnology power that delivers solutions in healthcare, energy, Al quality management, and other innovative industries. From life's conception to its completion, CU aims to provide end-to-end support through complete supplychain resources and services. UC reagent is part of CorDx Union (CU) totaling 21 subsidiaries under the CU umbrella.
					</div>
				</div>
				<div class="list_box">
					<div class="left">
						<div class="list_el">
							<div class="tit">
								<count-to :startVal="0" :endVal="25000" :duration="6000" separator="" class="num"></count-to>
								<span class="tips">+</span>
							</div>
							<div class="txt">25,000m² industrial</div>
						</div>
						<div class="list_el" style="margin-top: 20px;">
							<div class="tit">
								<count-to :startVal="0" :endVal="15" :duration="3000" separator="" class="num"></count-to>
								<span class="tips">+</span>
							</div>
							<div class="txt">Years of Experience</div>
						</div>
					</div>
					<div class="right">
						<div class="list_el">
							<div class="tit">
								<count-to :startVal="0" :endVal="1000" :duration="6000" separator="" class="num"></count-to>
								<span class="tips">+</span>
							</div>
							<div class="txt">Global Business Partners</div>
						</div>
						<div class="list_el" style="margin-top: 20px;">
							<div class="tit">
								<count-to :startVal="0" :endVal="800" :duration="5000" separator="" class="num"></count-to>
								<span class="tips">+</span>
							</div>
							<div class="txt">Innovative Products</div>
						</div>
					</div>
				</div>
			</div>
			<!--块5-->
			<!--块6-->
			<div v-if="false" class="block_6"
				data-aos="fade-up"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="tit_box">
					<div class="left"></div>
					<div class="center">
						<div class="title">Our Organization</div>
						<div class="tit">ABOUT US</div>
					</div>
					<div class="right"></div>
				</div>
				<div
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
					class="web_box"
				>
					<div class="web_el">
						<a href="https://cordx.com/">
							<img src="../../assets/img/about/web1.webp" />
							<div class="tit">CorDx</div>
							<div class="txt">Diagnostic platform for innovation, manufacturing, and supply.</div>
						</a>
					</div>
					<div class="web_el">
						<a href="https://coretests.com/">
							<img src="../../assets/img/about/web2.webp" />
							<div class="tit">Core tests</div>
							<div class="txt">Precision, reliable, and use-friendly testing solutions for IVD and more.</div>
						</a>
					</div>
					<div class="web_el" style="cursor: auto;">
						<img src="../../assets/img/about/web3.webp" />
						<div class="tit">Accu News</div>
						<div class="txt">Manufacture pharmaceutical preparations, instruments, testers and more</div>
					</div>
					<div class="web_el">
						<a href="https://www.abiores.com/en/">
							<img src="../../assets/img/about/web4.webp" />
							<div class="tit">Abiores</div>
							<div class="txt">PCR solutions for diagnostic testing, research, and development.</div>
						</a>
					</div>
					<div class="web_el">
						<a href="https://m.bonore.com/">
							<img src="../../assets/img/about/web5.webp" />
							<div class="tit">Bono Plastics</div>
							<div class="txt">Consumable supplies and resources for diagnostic production and development.</div>
						</a>
					</div>
					<div class="web_el">
						<a href="https://en.cupet.com/">
							<img src="../../assets/img/about/web6.webp" />
							<div class="tit">CuPet</div>
							<div class="txt">One-Stop Animal Diagnostic Solutions.</div><br />
						</a>
					</div>
				</div>
			</div>
			<!--块6-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navBox from '@/component/h5/nav.vue'  //导航组件
import footerBox from '@/component/h5/footer.vue'  //版权组件
import contact from '@/component/h5/contact.vue'  //联系我们组件
import { UPURL } from '@/util/util.js';
import CountTo from 'vue-count-to';
import { getAbout } from '@/api/public';
export default {
	components:{
		navBox,
		footerBox,
		CountTo
	},
	data() {
		return {
			isLoading: true,  //界面loading
			productType: [],
			productList: [],
			productList2: [],
			appsList: [],
			servicesList: []
		}
	},
	created(){
		let that = this;
		if(sessionStorage.getItem('navData')) {
			that.productType = JSON.parse(sessionStorage.getItem('navData')).cate_list;
			// that.productList = JSON.parse(sessionStorage.getItem('navData')).diseases_list;
			that.appsList = JSON.parse(sessionStorage.getItem('navData')).apps_list;
			that.servicesList = JSON.parse(sessionStorage.getItem('navData')).service_list;
		}
	},
	mounted() {
		let that = this;
		getAbout().then(res => {
			that.productList = res.data.diseases_list;
			that.productList2 = res.data.diseases_lists;
			that.isLoading = false;
		});
	},
	methods: {
		//跳转产品
		goProducts(type, value) {
			let that = this;
			switch(type) {
				case 1:
					that.$router.push({ path: '/products', query: { type: value.id } });
				break;
				case 2:
					that.$router.push({ path: '/products', query: { disease: value.id } });
				break;
				case 3:
					that.$router.push({ path: '/products', query: { tests: value.id } });
				break;
			}
		},
		//跳转服务
		goServices() {
			this.$router.push('/services');
		},
		//跳转im
		goIm() {
			window.location.href = 'https://i-membrane.com/';
		},
		goHome() {
			this.$router.push('/');
		}
	}
}
</script>

<style lang="less" scoped>
.main_box{
	color: #000000;
	font-size: 14px;
	//块6
	.block_6{
		padding: 0px 20px 50px 20px;
		.web_box{
			padding-top: 0px;
			.web_el{
				margin-top: 20px;
				padding: 0px 20px 20px 20px;
				background-color: #ffffff;
				text-align: center;
				border-radius: 6px;
				border: 1px solid #CCCCCC;
				.txt{
					font-size: 16px;
					color: #706B69;
				}
				.tit{
					padding: 0px 0 5px 0;
					font-size: 20px;
				}
				img{
					width: 100%;
				}
				a{
					color: #000000;
				}
			}
			.tit{
				font-size: 24px;
				text-align: center;
			}
		}
		.tit_box{
			display: flex;
			align-items: center;
			padding-bottom: 5px;
			.center{
				flex: 1;
				text-align: center;
				.tit{
					font-size: 18px;
					color: #CCCCCC;
				}
				.title{
					font-size: 24px;
				}
			}
			.left, .right{
				width: 40px;
				height: 1px;
				background-color: #CCCCCC;
			}
		}
	}
	//块5
	.block_5{
		padding: 50px 20px;
		.list_box{
			display: flex;
			padding-top: 20px;
			.list_el{
				width: 100%;
				padding: 5px;
				text-align: center;
				.txt{
					color: #E37542;
					font-size: 14px;
				}
				.tit{
					position: relative;
					padding-top: 12px;
					.num{
						font-size: 42px;
						color: #006BB3;
						line-height: 1;
					}
					span.tips{
						position: absolute;
						top: 0px;
						color: #006BB3;
						font-size: 24px;
					}
				}
				img{
					width: 32px;
				}
			}
			.left{
				flex: 1;
				padding-right: 10px;
			}
			.right{
				flex: 1;
				padding-left: 10px;
			}
		}
		.title_box{
			.txt{
				font-size: 16px;
				color: #1A1819;
			}
			.tit{
				padding: 15px 0;
				font-size: 20px;
				text-align: center;
			}
		}
		.tit_box{
			display: flex;
			align-items: center;
			padding-bottom: 5px;
			.center{
				flex: 1;
				text-align: center;
				.tit{
					font-size: 18px;
					color: #CCCCCC;
				}
				.title{
					font-size: 24px;
				}
			}
			.left, .right{
				width: 40px;
				height: 1px;
				background-color: #CCCCCC;
			}
		}
	}
	//块4
	.block_4{
		padding: 50px 30px;
		text-align: center;
		color: #ffffff;
		background-color: #E37542;
		.text{
			padding: 4px;
			font-size: 18px;
		}
		.title{
			font-size: 28px;
		}
	}
	//块3
	.block_3{
		padding: 0px 20px 50px 20px;
		.list_box{
			padding: 20px 0px 0 0px;
			.img_box{
				img{
					width: 100%;
					display: inline-block;
					margin-bottom: 10px;
				}
			}
			.btn_box{
				text-align: center;
				color: #E37542;
				font-size: 18px;
			}
			.list_el{
				padding: 2px 0;
				text-align: center;
				font-size: 18px;
			}
		}
		.tit_box{
			display: flex;
			align-items: center;
			padding-bottom: 5px;
			.center{
				flex: 1;
				text-align: center;
				.tit{
					font-size: 18px;
					color: #CCCCCC;
				}
				.title{
					font-size: 24px;
				}
			}
			.left, .right{
				width: 40px;
				height: 1px;
				background-color: #CCCCCC;
			}
		}
	}
	//块2
	.block_2{
		padding: 0px 20px 50px 20px;
		.list_box{
			.list_el{
				margin-bottom: 10px;
				padding: 15px 20px;
				background-color: #F6F6F6;
				.list_el_el{
					display: flex;
					align-items: center;
					padding: 10px 0;
					img{
						width: 18px;
					}
					div{
						flex: 1;
						font-size: 16px;
					}
				}
				.tit{
					margin-bottom: 10px;
					padding-bottom: 6px;
					font-size: 16px;
					color: #808080;
					border-bottom: 1px solid #CCCCCC;
				}
			}
			.list_tit{
				display: flex;
				align-items: center;
				margin-bottom: 10px;
				padding: 15px 20px;
				background-color: #F6F6F6;
				img{
					width: 18px;
				}
				div{
					flex: 1;
					font-size: 16px;
					font-weight: bold;
				}
			}
		}
		.tit_box{
			display: flex;
			align-items: center;
			padding-bottom: 5px;
			.center{
				flex: 1;
				text-align: center;
				.tit{
					font-size: 18px;
					color: #CCCCCC;
				}
				.title{
					font-size: 24px;
				}
			}
			.left, .right{
				width: 40px;
				height: 1px;
				background-color: #CCCCCC;
			}
		}
	}
	//块1
	.block_1{
		padding: 50px 20px;
		.title_box{
			.txt{
				padding: 10px 0;
				color: #1A1819;
				font-size: 16px;
			}
			.tit{
				padding: 10px 0 5px 0;
				text-align: center;
				font-size: 24px;
			}
		}
		.tit_box{
			display: flex;
			align-items: center;
			padding-bottom: 5px;
			.center{
				flex: 1;
				text-align: center;
				.tit{
					font-size: 18px;
					color: #CCCCCC;
				}
				.title{
					font-size: 24px;
				}
			}
			.left, .right{
				width: 40px;
				height: 1px;
				background-color: #CCCCCC;
			}
		}
	}
	//banner
	.banner_box{
		position: relative;
		.msg_box{
			width: 100%;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			padding: 0 20px;
			text-align: center;
			.txt{
				font-size: 18px;
				color: #ffffff;
			}
			.tit{
				font-size: 36px;
				color: #ffffff;
			}
		}
		img{
			width: 100%;
		}
	}
}
</style>